module.exports = __webpack_public_path__ + "static/media/grin-alt.b4061c35.svg";